module.exports = __webpack_public_path__ + "img/icon_service_info_total_2.7eac273a.png";